<template>
  <default-layout>
    <div class="companies">
      <v-data-table
        :headers="headers"
        :items="companies"
        :items-per-page="size"
        :server-items-length="serverItemsLength"
        :options.sync="paginationOptions"
        item-key="id"
        :loading="loading"
        class="elevation-2"
        :multi-sort="false"
        :must-sort="true"
        sort-by="name"
        :footer-props="{
          'items-per-page-options': [10, 20, 50, 100]
        }"
        @update:options="updatePaginationOptions($event)"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Providers</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              @keyup.enter="searchCompanies"
            ></v-text-field>
          </v-toolbar>
        </template>

        <!-- LISTINGS SLOT -->
        <template v-slot:item.facilities="{ item }">
          <span
            v-for="facility in item.facilities.slice(0, 5)"
            :key="facility.id"
            >{{ facility.externalId }} &mdash; {{ facility.name }}<br
          /></span>
          <span v-if="item.facilities && item.facilities.length > 5"
            >...and {{ item.facilities.length - 5 }} more.</span
          >
        </template>

        <template v-slot:item.connectCompany="{ item }">
          {{ item.connectCompany ? "Yes" : "No" }}
        </template>

        <template v-slot:item.links="{ item }">
          <v-btn
            :to="{ name: 'CompanyShow', params: { companyId: item.id } }"
            small
            color="primary"
            >View</v-btn
          >
        </template>
      </v-data-table>
    </div>
  </default-layout>
</template>

<script>
import { listCompanies } from "../../api/company";

export default {
  name: "Companies",
  title: "Companies",

  data() {
    return {
      facility: null,
      companies: [],
      page: 0,
      size: 10,
      orderBy: "name",
      order: "asc",
      expanded: [],
      singleExpand: false,
      paginationOptions: {
        itemsPerPage: 10,
        page: 1
      },
      serverItemsLength: 0,
      loading: false,
      search: "",
      awaitingSearch: false,
      headers: [
        { text: "ID", value: "id" },
        { text: "Name", value: "name" },
        { text: "Listings", value: "facilities", sortable: false },
        { text: "Account", value: "connectCompany", sortable: false },
        { text: "", value: "links" },
        { text: "", value: "data-table-expand" }
      ]
    };
  },

  methods: {
    async searchCompanies() {
      this.offset = 0;
      this.paginationOptions.page = 1;

      await this.getCompanies();
      this.awaitingSearch = false;
    },

    updatePaginationOptions(paginationOptions) {
      this.page = paginationOptions.page - 1;
      this.size = paginationOptions.itemsPerPage;

      this.getCompanies();
    },

    async getCompanies() {
      try {
        this.loading = true;
        const result = await listCompanies(this.page, this.size, this.search);
        this.serverItemsLength = result.total;
        this.companies = result.items;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
    }
  }
};
</script>
